module.exports = __webpack_public_path__ + "media/images/filter-62a6e7fda5931623cb13ce6f33fa893e.svg";